export enum ChallengeTemplateType {
    Exam = 2,
    Before = 0,
    After = 1,
    AutoRetry = 3,
    AiGenerated = 4,
}

export enum ChallengeOrder {
    /** 교육과정 순 */
    Id = 2,
    /** 최신순 */
    Latest = 0,
    /** 오래된 순 */
    Oldest = 1,
}

export enum ChallengeStatus {
    /** 시작전 */
    NotStarted = 0,
    /** 진행중 */
    Inprogress = 1,
    /** 완료 */
    Completed = 2,
}
